import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import {
  Condition,
  conditionApi,
  ConditionType,
  Warehouse,
  warehouseApi,
} from "@/api/misc";

export interface WarehouseState {
  warehouses: Warehouse[];
}

const warehouseModule: Module<WarehouseState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      warehouses: [] as Warehouse[],
    } as WarehouseState),
  mutations: {
    setWarehouses(state: WarehouseState, warehouses: Condition[]): void {
      state.warehouses = warehouses;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<WarehouseState, RootState>
    ): Promise<void> {
      if (!context.state.warehouses || context.state.warehouses.length === 0) {
        context.commit("setWarehouses", await warehouseApi.listWarehouses());
      }
    },
    async addWarehouse(
      context: ActionContext<WarehouseState, RootState>,
      warehouse: Warehouse
    ): Promise<void> {
      await warehouseApi.addWarehouse(warehouse);
      context.commit("setWarehouses", await warehouseApi.listWarehouses());
    },
    async editWarehouse(
      context: ActionContext<WarehouseState, RootState>,
      warehouse: Warehouse
    ): Promise<void> {
      if (warehouse.id) {
        await warehouseApi.editWarehouse(warehouse);
        context.commit("setWarehouses", await warehouseApi.listWarehouses());
      }
    },
    async removeWarehouse(
      context: ActionContext<WarehouseState, RootState>,
      warehouse: Warehouse
    ): Promise<void> {
      if (warehouse.id) {
        await warehouseApi.deleteWarehouse(warehouse);
        context.commit("setWarehouses", await warehouseApi.listWarehouses());
      }
    },
  },
};

export default warehouseModule;
